//COLORS

export const HeadText = '#0075FE';
export const TextBlack = '#000000';
export const TextWhite = "#FFFFFF";
export const Whitegrey = "#CBC9C9";
export const GreyBg = "#F1F1F1";
export const violet = "#6C50D3";
export const pink = "#B13BA4";
export const grey = "#686463";
export const lytblack = "#42403F"

// FONT

export const small = '0.8em';
export const medium = '1em';
export const greater = '1.5em';
export const big = '1.8em';
export const large = '4.5em';
export const navSize = '1.2vw';
export const bold = 900;
export const regular = 500;
export const thin = 300;
